import Cookie from 'vue-cookie';

const helper = vue => ({
  isLoggedIn: !!Cookie.get('uuid'),
  roles: JSON.parse(Cookie.get('roles') || '[]'),
  expires: '8h',

  rolesCookieUpdate(newRoles) {
    this.roles = newRoles;
    Cookie.set('roles', JSON.stringify(newRoles), { expires: this.expires });
  },
  // Post form data for auth
  login(authData) {
    return new Promise((resolve) => {
      vue.http.post('login', authData)
        .then((res) => {
          if (res.body.status !== 'Success') throw new Error();
          Cookie.set('uuid', res.body.sessionId, { expires: this.expires });
          Cookie.delete('companyedit');
          localStorage.currentUser = JSON.stringify(res.body);
          this.isLoggedIn = true;
          return vue.http.get('account/roles');
        })
        .then((res) => {
          if (res.body.status !== 'Success') throw new Error();
          this.rolesCookieUpdate(res.body.roles);
          resolve(null);
        })
        .catch((err) => {
          this.logout();
          resolve('Failed to log in');
        });
    });
  },

  logout() {
    this.roles = [];
    this.isLoggedIn = false;
    this.loginProcessStarted = false;
  },

  // Check if uuid exists
  isLoggedIn() {
    return this.isLoggedIn;
  },

});
/* eslint-disable */
const auth = {
  install(Vue) {
    Vue.prototype.$auth = helper(Vue);
  },
};

export default auth;



// WEBPACK FOOTER //
// ./src/auth/index.js